import styled from 'styled-components';
import images from '../img';

function ResultContent({
    pictureUrl,
    title,
    description
}) {
    return (<ResultContentStyleWrapper className="result-content">
        <div className='picture' style={{
            backgroundImage: `url(${images["result/" + pictureUrl]})`
        }}></div>
        <div className='title' dangerouslySetInnerHTML={{
            __html: title
        }} />
        <div className='description' dangerouslySetInnerHTML={{
            __html: description
        }} />
    </ResultContentStyleWrapper>);
}

export default ResultContent;

const ResultContentStyleWrapper = styled.div`
    padding-top:5.9rem;
    position: relative;
    &::before{
        content: "";
        display: block;
        width: 2.4rem;
        height:2.4rem;
        background-color: #830001;
        border:0.8rem solid #fff;
        border-radius: 50%;
        position: absolute;
        top:0;
        left:50%;
        transform: translate(-50%,-50%);
    }
    .picture{
        width: 50rem;
        height:25rem;
        margin-bottom:3rem;
        background-color: #edeeef;
        background-size: cover;
    }
    .title{
        margin-bottom: 1.7rem;
        font-size: 3.1rem;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: -0.031rem;
        text-align: left;
        word-break: keep-all;
        color: #000
    }
    .description{
        word-break: keep-all ;
        font-size: 2.2rem;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.45;
        letter-spacing: -0.055rem;
        text-align: left;
        color: #6f7175;
    }
`;